"use client"
import AddressInformation from "@/app/(site)/[locale]/checkout/CheckoutContent/components/OrderSummery/AddressInformation"
import SelectedShippingMethodRow from "@/app/(site)/[locale]/checkout/CheckoutContent/components/SelectedShippingMethodRow"
import { type MarketLayout } from "@/app/(site)/[locale]/checkout/types"
import Checkbox from "@/app/(site)/_components/Atoms/Inputs/checkbox"
import useSWRBasketSessionState from "@/app/(site)/_utils/_hooks/SWR/useSWRBasketSessionState"
import { useGetSameShippingAddress } from "@/app/(site)/_utils/_hooks/useGetSameShippingAddress"
import {
    applyFreeShippingToCheapestMethod,
    getShippingMethodPriceLabel
} from "@/lib/utils/checkout/shippingUtils"
import { parseShippingMethodName } from "@/lib/utils/checkout/voucherUtils"
import { t } from "@/translations"
import { clsx } from "@/src/utils/clsx"

export default function StepSummary({
    step,
    langCode,
    className,
    marketLayout
}: {
    step: number
    langCode: string
    className?: string
    marketLayout?: MarketLayout
}) {
    const { selection, countriesWithStates, shippingMethods } = useSWRBasketSessionState()
    const updatedShippingMethods = applyFreeShippingToCheapestMethod(
        shippingMethods,
        selection?.discounts?.vouchers || [],
        langCode
    )
    const { name: methodName, deliveryTime } = parseShippingMethodName(
        selection?.shippingMethodName ?? "",
        langCode
    )

    const sameShippingAddress = useGetSameShippingAddress()

    const shippingAddress = selection?.shippingAddress
    const billingAddress = selection?.address
    const selectedShippingMethod = updatedShippingMethods.find(
        method => method.shippingMethod === selection?.shippingMethod
    )

    const shippingPriceLabel = getShippingMethodPriceLabel(
        langCode,
        selectedShippingMethod?.priceAsNumber ?? 0,
        selectedShippingMethod?.price
    )

    return step === 1 ? (
        <div className={clsx("flex flex-col Trade_Gothic_Text_14_150_0_300", className)}>
            <div className="flex flex-col gap-2">
                <AddressInformation
                    isNAMarket={marketLayout === "na"}
                    countriesWithStates={countriesWithStates}
                    shippingAddress={shippingAddress}
                />
            </div>

            <div className="mb-4 mt-16 flex h-24 select-none appearance-none items-center gap-4 text-col-text-primary">
                <Checkbox
                    name="sameShippingAddress"
                    label={t(langCode, "checkout.billing_address_same_as_shipping")}
                    defaultValue={sameShippingAddress}
                    disabled
                    onChange={() => {}}
                    labelClassName="mt-16 mb-2"
                />
            </div>

            {!sameShippingAddress && (
                <div className="flex flex-col gap-2 Trade_Gothic_Text_14_150_0_300">
                    <AddressInformation
                        isNAMarket={marketLayout === "na"}
                        countriesWithStates={countriesWithStates}
                        billingAddress={billingAddress}
                        getShippingAddress={false}
                    />
                </div>
            )}
        </div>
    ) : step === 2 ? (
        <div className="pb-32">
            <SelectedShippingMethodRow
                methodName={methodName}
                deliveryTime={deliveryTime}
                priceLabel={shippingPriceLabel}
            />
        </div>
    ) : null
}
